import { Alert, Box, Chip, Dialog, DialogContent, DialogTitle, Table, TableBody, TableCell, TableRow, Typography } from "@mui/material";
import { useAtom } from "jotai";
import { FC, useEffect, useState } from "react";
import { modalEvents } from "../../atoms/atom";
import { ComparationService } from "../../services/ComparationService";
import { Events2210DTO } from "../../types/Events2210DTO";
import { Events2220DTO } from "../../types/Events2220DTO";
import { Events2240DTO } from "../../types/Events2240DTO";
import { useUtils } from "../../utils/utilFunctions";
import './EventsDialog.scss';

interface EventsProps {
	id: number;
	eventType: string;
}

const EventsDialog: FC<EventsProps> = (props: EventsProps) => {
	const [open, setOpen] = useAtom(modalEvents);
	const [events2210, setEvents2210] = useState<Events2210DTO>();
	const [events2220, setEvents2220] = useState<Events2220DTO>();
	const [events2240, setEvents2240] = useState<Events2240DTO>();
	const service = new ComparationService();
	const { formatStringDate, formatStringDateReverse } = useUtils();
	const header = (name: string) => {
		return <TableCell className="cell-bold">{name}</TableCell>
	}
	const cellValue = (v: string) => {
		return <TableCell className="cell">{v}</TableCell>
	}

	useEffect(() => {
		const load = async () => {
			switch (props.eventType) {
				case "2210":
					const response10 = await service.getEvents2210(props.id);
					if (response10?.data) {
						setEvents2210(response10.data);
					}
					break;
				case "2220":
					const response20 = await service.getEvents2220(props.id);
					if (response20?.data) {
						setEvents2220(response20.data);
					}
					break;
				default:
					const response40 = await service.getEvents2240(props.id);
					if (response40?.data) {
						setEvents2240(response40.data);
					}
					break;
			}
		};
		if (props.id && props.eventType) load();
	}, [props.id, props.eventType]);

	return (
		<Dialog open={open} onClose={() => setOpen(false)}>
			<DialogTitle>
				Eventos {props.eventType}
			</DialogTitle>
			<DialogContent id="events-table">
				{getErros().map((error) => (
					<Alert severity="error">
						{error}
					</Alert>
				))}
				<div className="flex">
					<Typography fontWeight="bold" variant="button">Data de admissão: </Typography>
					<Typography variant="button">{getAdmissionDate()}</Typography>
				</div>
				<div className="flex">{getDemissionDate()}</div>
				<Typography fontWeight="bold" variant="button">Eventos: </Typography>
				{renderTableByType()}
			</DialogContent>
		</Dialog>
	);

	function getErros() {
		switch (props.eventType) {
			case "2210":
				return events2210?.errors.filter(i => !!i) || [];
			case "2220":
				return events2220?.errors.filter(i => !!i) || [];
			default:
				return events2240?.errors.filter(i => !!i) || [];
		}
	}

	function renderTableByType() {
		switch (props.eventType) {
			case "2210":
				return renderTable2210();
			case "2220":
				return renderTable2220();
			default:
				return renderTable2240();
		}
	}

	function getAdmissionDate() {
		switch (props.eventType) {
			case "2210":
				return events2210?.admissionDate;
			case "2220":
				return events2220?.admissionDate;
			default:
				return events2240?.admissionDate;
		}
	}

	function getDemissionDate() {
		let value;
		switch (props.eventType) {
			case "2210":
				value = events2210?.demissionDate;
				break;
			case "2220":
				value = events2220?.demissionDate;
				break;
			default:
				value = events2240?.demissionDate;
		}
		return value
			? <>
				<Typography fontWeight="bold" variant="button">Data de demissão: </Typography>
				<Typography variant="button">{value}</Typography>
			</>
			: <></>;
	}

	function renderTable2210() {
		return events2210
			? events2210.events.map((i) => (
				<Table>
					<TableBody>
						<TableRow>
							{header("Data do acidente")}
							{cellValue(formatStringDate(i.dataAcidente))}
						</TableRow>
						<TableRow>
							{header("Data de envio do evento")}
							{cellValue(formatStringDateReverse(i.dataEnvio))}
						</TableRow>
					</TableBody>
				</Table>
			))
			: <></>
	}

	function renderTable2220() {
		return events2220
			? events2220.events.map((i) => (
				<Table>
					<TableBody>
						<TableRow>
							{header("Data do exame")}
							{cellValue(formatStringDate(i.dataASO))}
						</TableRow>
						<TableRow>
							{header("Tipo")}
							{cellValue(formatStringDateReverse(i.dsExame))}
						</TableRow>
					</TableBody>
				</Table>
			))
			: <></>
	}

	function renderTable2240() {
		return events2240
			? events2240.events.map((i) => (
				<Table>
					<TableBody>
						<TableRow>
							{header("Data de início da condição")}
							{cellValue(formatStringDate(i.dataInicioCondicao))}
						</TableRow>
						<TableRow>
							{header("Descrição das atividades preenchida")}
							{cellValue(i.descricaoAtividade ? "Sim" : "Não")}
						</TableRow>
						<TableRow>
							{header("Agentes")}
							<TableCell sx={{padding: "6px", paddingLeft: "10px"}} className="cell">
								{i.agentes
									? i.agentes.map((agent) => (
										<Chip label={agent}/>
									))
									: "Nenhum"
								}
							</TableCell>
						</TableRow>
					</TableBody>
				</Table>
			))
			: <></>
	}
}

export default EventsDialog;